import { Component, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AlertService } from '@app/shared/alert/alert.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Location } from '@angular/common';
import Utils from '@app/shared/utils';
import { MachinesService } from '../machines.service';

@Component({ template: '' })
export class AddEditComponent implements OnInit {
        
    constructor(public dialog: MatDialog,
        private location: Location,
        private formBuilder: FormBuilder,
        private machinesService: MachinesService,
        private alertService: AlertService,
        private route: ActivatedRoute,
        private router: Router,
        private matDialog: MatDialog
    ) { }

    ngOnInit() {
        this.openDialog();
    }

    openDialog(): void {
        let id = this.route.snapshot.params['id']
        const dialogRef = this.dialog.open(AddEditComponentDialog, {
            data: {
                formBuilder: this.formBuilder,
                id: id,
                isAddMode: !id,
                machinesService: this.machinesService,
                alertService: this.alertService,
                route: this.route,
                router: this.router,
                matDialog: this.matDialog
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            this.location.back();
        });
    }
}

@Component({ templateUrl: 'add-edit.component.html' })
export class AddEditComponentDialog implements OnInit {
    form: FormGroup;
    id: string;
    isAddMode: boolean;
    loading = false;
    submitted = false;
    isModal: boolean;
    private versionId: string;
    private modelId: string;

    constructor(
        public dialogRef: MatDialogRef<AddEditComponentDialog>,
        private machinesService: MachinesService,
        private alertService: AlertService,
        @Inject(MAT_DIALOG_DATA) public data: {
            formBuilder: FormBuilder, 
            id: string, 
            isAddMode: boolean,
            machinesService: MachinesService,
            alertService: AlertService,
        }
    ) {
        this.id = data.id;
        this.isAddMode = data.isAddMode;
        this.machinesService = data.machinesService;
        this.alertService = data.alertService;
    }

    ngOnInit() {
        
        
        this.form = this.data.formBuilder.group({
            type: [''],
            brand: [''],
            serialNumber: [''],
        });
        if (!this.isAddMode) {
            var model = this.machinesService.recordsValue["results"].find(x => x.modelId == this.id);
            this.versionId = model["versionId"];
            this.modelId = model["modelId"];
            this.form.patchValue(Utils.mapModelToForm(model));
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;
        if (this.isAddMode) {
            this.createMachine();
        } else {
            this.updateMachine();
        }
    }

    private createMachine() {
        this.machinesService.add(this.form.value)
            .pipe(first())
            .subscribe({
                next: () => {
                    this.alertService.success('Machine added successfully', { keepAfterRouteChange: true });
                    this.dialogRef.close()
                },
                error: error => {
                    this.alertService.error(error);
                    this.loading = false;
                }
            });
    }

    private updateMachine() {
        this.machinesService.update(this.form.value,this.modelId, this.versionId)
            .pipe(first())
            .subscribe({
                next: () => {
                    this.alertService.success('Update successful', { keepAfterRouteChange: true });
                    this.dialogRef.close()
                },
                error: error => {
                    this.alertService.error(error);
                    this.loading = false;
                }
            });
    }
}